import { ViewIcon } from '@chakra-ui/icons';
import {
    Badge,
    Box,
    Button,
    Center,
    HStack,
    Heading,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasPermission, useTableColors } from '../../Utils';
import { fetchSubscriptions } from '../../api';
import AccessDenied from '../../components/AccessDenied';

export default function SubscriptionsPage() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const coolors = useTableColors();

    const loadData = async () => {
        setLoading(true);
        const res = await fetchSubscriptions({ page, limit: 50 });
        if (res.success) {
            setData(res.data.subscriptions);
            setTotalPages(res.data.totalPages || 1);
        }
        setLoading(false);
    };

    useEffect(() => { loadData(); }, [page]);

    if (loading) {
        return <Center mt="20%"><Spinner size="xl" /></Center>;
    }

    if (!hasPermission('viewSubscriptions')) {
        return <AccessDenied msg="You don't have permission to view this page" />;
    }

    return (
        <Box w={'full'}>
            <Heading size="lg" mb={4}>Active Subscriptions</Heading>

            <Table size="sm" variant="simple">
                <Thead bg={coolors.theadBg}>
                    <Tr>
                        <Th>First Name</Th>
                        <Th>Last Name</Th>
                        <Th>Payment For</Th>
                        <Th>Amount</Th>
                        <Th>Status</Th>
                        <Th>Total</Th>
                        <Th>Past Occurrences</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {data.map((sub, index) => (
                        <Tr
                            key={sub.id}
                            bg={index % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                            color={coolors.textColor}
                            _hover={{ bg: coolors.rowHoverBg, color: "white" }}
                            fontWeight="bold"
                        >
                            <Td>{sub?.firstName || "N/A"}</Td>
                            <Td>{sub?.lastName || "N/A"}</Td>
                            <Td>{sub.name}</Td>
                            <Td>${sub.amount}</Td>
                            <Td>
                                <Badge size="xs" colorScheme="green">
                                    {sub.status}
                                </Badge>
                            </Td>
                            <Td>{sub.totalOccurrences}</Td>
                            <Td>{sub.pastOccurrences || 0}</Td>
                            <Td>
                                <Button
                                    size="xs"
                                    colorScheme="green"
                                    onClick={() => navigate(`/transaction/subscription/${sub.id}`)}
                                >
                                    <ViewIcon />
                                </Button>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>



            <HStack mt={6} spacing={4}>
                <Button onClick={() => setPage((p) => Math.max(p - 1, 1))} isDisabled={page === 1}>
                    Prev
                </Button>
                <Text>Page {page} of {totalPages}</Text>
                <Button onClick={() => setPage((p) => Math.min(p + 1, totalPages))} isDisabled={page === totalPages}>
                    Next
                </Button>
            </HStack>
        </Box>
    );
}
